module.exports = __webpack_public_path__ + "img/futurePoints3.de7e1186.png";